import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockBatchValuationReportData} from "./stock-batch-valuation-report.data";

@Injectable()
export class StockBatchValuationReportModel extends ReportModel<StockBatchValuationReportData> {
    constructor(injector: Injector) {
        super(injector, StockBatchValuationReportData);
    }
}
